/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Instructions_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "New instructions apply to all new chats in the project immediately. Existing conversations keep the context they already have. A persona can override the ton..." |
*
* @param {Uno_Edu_Project_Instructions_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_instructions_chip2_answer = /** @type {((inputs?: Uno_Edu_Project_Instructions_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Instructions_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Anweisungen gelten sofort für alle neuen Chats im Projekt. Bestehende Konversationen behalten ihren vorhandenen Kontext. Eine Persona kann den Ton für einen einzelnen Chat überschreiben.")
	return /** @type {LocalizedString} */ ("New instructions apply to all new chats in the project immediately. Existing conversations keep the context they already have. A persona can override the tone for a single chat.")
});